import { combineReducers } from 'redux';

// combineReducers({}) with no keys makes the store invalid and logs
// "Store does not have a valid reducer" on every page. Nothing reads from
// redux yet, so keep one inert slice until real state shows up.
const app = (state = {}) => state;

const rootReducer = combineReducers({
    app,
});

export default rootReducer;
